import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import ProcessButton from "../controls/ProcessButton";
import {Token, UserContext} from "../auth/Auth";
import BackEnd from "../backend/BackEnd";
import MaskedInput from "../controls/MaskedInput";
import ActionLink from "../controls/ActionLink";

class LoginModal extends Component {
    static propTypes = {
        beforeForm: PropTypes.node,
        intent: PropTypes.string,
        show: PropTypes.bool.isRequired,
        onLogin: PropTypes.func.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {
        beforeForm: '',
        intent: 'NoIntent'
    };
    state = {
        isLoading: false,
        ...LoginModal.initialState()
    };
    sendSecurityCode = new BackEnd.Authentication.SendSecurityCode(this);
    signIn = new BackEnd.Authentication.SignIn(this);

    static initialState() {
        return {
            step: 'PhoneNumber',
            phoneNumber: '',
            code: '',
            timerValue: 60,
            canResendCode: false
        }
    }

    componentWillReceiveProps({show}) {
        if (show) {
            this.setState(LoginModal.initialState());
            this.resetTimer();
        }
        else {
            if (this.interval)
                clearInterval(this.interval);
        }
    }

    render() {
        const {beforeForm, onLogin, ...props} = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Авторизация</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className={this.state.isLoading ? 'form-loading' : ''}>
                        {beforeForm}
                        <div className="row">
                            <div className="col-md-4 col-md-offset-4">
                                {
                                    this.state.step === 'PhoneNumber' &&
                                    <fieldset className={`form-group form-group-lg ${this.state.hasError ? 'has-error' : ''}`}>
                                        <label className="m-b-2" htmlFor="phone-number">
                                            Номер телефона
                                        </label>
                                        <div className="input-group">
                                            <div className="input-group-addon">
                                                <span className="flag-icon flag-icon-ru"/> +7
                                            </div>
                                            <MaskedInput type="text" className="form-control" id="phone-number"
                                                         mask="(999) 999-9999"
                                                         value={this.state.phoneNumber}
                                                         onChange={event => this.setState({phoneNumber: event.target.value})}/>
                                        </div>
                                        {
                                            this.state.hasError &&
                                            <small class="form-message light">Укажите номер телефона</small>
                                        }
                                    </fieldset>
                                }
                                {
                                    this.state.step === 'Code' &&
                                    <div>
                                        <fieldset className="form-group form-group-lg">
                                            <label className="m-b-2" htmlFor="code">
                                                Код безопасности
                                            </label>
                                            <MaskedInput type="text" className="form-control text-center" id="code"
                                                         mask="9 9 9 9"
                                                         value={this.state.code}
                                                         onChange={event => this.setState({code: event.target.value})}/>
                                        </fieldset>
                                        <div className="text-center">
                                            {
                                                !this.state.canResendCode &&
                                                <span className="font-size-12">
                                            Повторная отправка возможна через {this.state.timerValue} сек.
                                        </span>
                                            }
                                            {
                                                this.state.canResendCode &&
                                                <ActionLink className="font-size-12"
                                                            onClick={() => this.resendCode()}>
                                                    Запросить код повторно
                                                </ActionLink>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    {
                        this.state.step === 'PhoneNumber' &&
                        <ProcessButton type="button" className="btn btn-primary"
                                       disabled={this.state.phoneNumber.replace(/[^\d]/g, '').length !== 10}
                                       isLoading={this.state.isLoading}
                                       onClick={() => this.submitPhoneNumber()}>
                            Получить код
                        </ProcessButton>
                    }
                    {
                        this.state.step === 'Code' &&
                        <ProcessButton type="button" className="btn btn-primary"
                                       disabled={this.state.code.replace(/[^\d]/g, '').length !== 4}
                                       isLoading={this.state.isLoading}
                                       onClick={() => this.submitCode()}>
                            Проверить
                        </ProcessButton>
                    }
                    <ProcessButton type="button" className="btn btn-default"
                                   isLoading={this.state.isLoading}
                                   onClick={props.onHide}>
                        Закрыть
                    </ProcessButton>
                </Modal.Footer>
            </Modal>
        );
    }

    async submitPhoneNumber() {
        if (this.state.isLoading)
            return;

        const phoneNumber = `7 ${this.state.phoneNumber}`;
        let result = await this.sendSecurityCode.call({
            dto: {
                phoneNumber
            }
        });

        if (result.success) {
            this.setState({step: 'Code'});
        }
    }

    async submitCode() {
        if (this.state.isLoading)
            return;

        const {intent, onLogin, onHide} = this.props;
        const phoneNumber = `7 ${this.state.phoneNumber}`;

        let {response, json} = await this.signIn.extendedCall({
            dto: {
                phoneNumber,
                securityCode: this.state.code,
                intent
            }
        });

        UserContext.set(json.data);
        Token.set(response.headers.get('Bearer'));

        onLogin();
        onHide();
    }

    intervalTick() {
        if (this.state.timerValue === 0)
            return;

        this.setState({
            timerValue: this.state.timerValue - 1,
            canResendCode: this.state.timerValue === 1
        });
    }

    resetTimer() {
        if (this.interval) clearInterval(this.interval);

        this.setState({
            timerValue: 60,
            canResendCode: false
        });

        this.interval = setInterval(() => this.intervalTick(), 1000);
    }

    async resendCode() {
        let result = await this.sendSecurityCode.call({
            dto: {
                phoneNumber: this.props.phoneNumber
            }
        });

        this.resetTimer();
    }
}

export default LoginModal;


// WEBPACK FOOTER //
// ./src/modals/LoginModal.js